import 'select2';
$(document).ready(function () {
  $('.js-select').select2({
    theme: 'bootstrap4'
  });
  $(document).on("select2:open", function () {
    document.querySelector(".select2-container--open .select2-search__field").focus();
  });
});